import { useEffect, useRef, useState } from "react";
import mermaid from "mermaid";

mermaid.initialize({
  startOnLoad: false,
  theme: "dark",
  securityLevel: "loose",
  fontFamily: "JetBrains Mono, monospace",
  themeVariables: {
    primaryColor: "#1E2532",
    primaryTextColor: "#F3F4F6",
    primaryBorderColor: "#7C3AED",
    lineColor: "#7C3AED",
    secondaryColor: "#151A22",
    tertiaryColor: "#0B0E14",
    background: "#0B0E14",
    mainBkg: "#1E2532",
    nodeBorder: "#7C3AED",
    clusterBkg: "#151A22",
    edgeLabelBackground: "#151A22",
  },
});

let idCounter = 0;

export default function Mermaid({ chart }) {
  const ref = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!chart || !ref.current) return;
    let cancelled = false;
    const id = `mermaid-${Date.now()}-${idCounter++}`;
    setError(false);
    mermaid
      .render(id, chart.trim())
      .then(({ svg }) => {
        if (!cancelled && ref.current) ref.current.innerHTML = svg;
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => { cancelled = true; };
  }, [chart]);

  if (error) {
    return (
      <pre className="text-xs text-muted-foreground font-mono-fin whitespace-pre-wrap bg-[#0B0E14] p-4 rounded-lg border border-border overflow-x-auto" data-testid="mermaid-fallback">
        {chart}
      </pre>
    );
  }

  return <div ref={ref} className="mermaid-container w-full overflow-x-auto flex justify-center" data-testid="mermaid-diagram" />;
}
